module.exports = __webpack_public_path__ + "img/shovel-snow.f62f8fcd.svg";